const userActionTypes = {
    SIGN_IN_WITH_EMAIL_START: "SIGN_IN_WITH_EMAIL_START",
    SIGN_IN_WITH_GOOGLE_START: "SIGN_IN_WITH_GOOGLE_START",
    SIGN_IN_SUCCESS: "SIGN_IN_SUCCESS",
    SIGN_IN_FAILURE: "SIGN_IN_FAILURE",
    SIGN_UP_START: "SIGN_UP_START",
    SIGN_UP_SUCCESS: "SIGN_UP_SUCCESS",
    SIGN_UP_FAILURE: "SIGN_UP_FAILURE",
    SIGN_OUT_START: "SIGN_OUT_START",
    SIGN_OUT_SUCCESS: "SIGN_OUT_SUCCESS",
    SIGN_OUT_FAILURE: "SIGN_OUT_FAILURE",
    CHECK_USER_SESSION: "CHECK_USER_SESSION"
}
export default userActionTypes